import React, { useState, useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { store } from './store';
import { useAppSelector, useAppDispatch } from './hooks/redux';
import { setLoading } from './store/slices/uiSlice';
import { lightTheme, darkTheme } from './theme';
import MainLayout from './components/Layout/MainLayout';
import LoadingScreen from './components/Layout/LoadingScreen';
import OfflineIndicator from './components/Mobile/OfflineIndicator';
import UpdateAvailableBanner from './components/Mobile/UpdateAvailableBanner';

function AppContent() {
  const theme = useAppSelector((state) => state.ui.theme);
  const loading = useAppSelector((state) => state.ui.loading);
  const dispatch = useAppDispatch();
  const currentTheme = theme === 'dark' ? darkTheme : lightTheme;
  const [isInitializing, setIsInitializing] = useState(true);

  useEffect(() => {
    // Simulate app initialization
    const initApp = async () => {
      try {
        // Load user preferences, initialize services, etc.
        await new Promise(resolve => setTimeout(resolve, 1500)); // Simulate loading time
        
        // Check for saved theme preference
        const savedTheme = localStorage.getItem('telix_theme');
        if (savedTheme === 'light' || savedTheme === 'dark') {
          // Theme is already set from Redux, but we could sync here if needed
        }

        setIsInitializing(false);
        dispatch(setLoading(false));
      } catch (error) {
        console.error('Failed to initialize app:', error);
        setIsInitializing(false);
        dispatch(setLoading(false));
      }
    };

    initApp();
  }, [dispatch]);

  if (isInitializing) {
    return (
      <ThemeProvider theme={currentTheme}>
        <CssBaseline />
        <LoadingScreen message="Initializing Telix Lab..." />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={currentTheme}>
      <CssBaseline />
      <Router>
        <MainLayout />
        <OfflineIndicator />
        <UpdateAvailableBanner />
      </Router>
    </ThemeProvider>
  );
}

function App() {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
}

export default App;
